import { render } from "./ModalBox.vue?vue&type=template&id=2717e5bc"
import script from "./ModalBox.vue?vue&type=script&lang=js"
export * from "./ModalBox.vue?vue&type=script&lang=js"

import "./ModalBox.vue?vue&type=style&index=0&id=2717e5bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__